module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar bundleLocked = false;\nif(typeof contentLocked !== 'undefined' && contentLocked == true){\n    bundleLocked = true;\n}\n%>\n\n<article class=\"show-browse-item\">\n    <a class=\"focusable\" href=\"<%= href %>\" aa-link=\"<%= aaLink %>\" data-fathom=\"<%= fathomData %>\" data-impression=\"<%= impressionData %>\">\n        <div class=\"thumb-wrapper\">\n          <% if(typeof thumb !== 'undefined'){ %>\n            <img class=\"thumb lazy\" src=\"data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=\" data-src=\"<%= thumb || '' %>\" alt=\"<%= title %>\" />\n          <% } %>\n          <% if(bundleLocked && CBS.Registry.user_auth && CBS.Registry.user.sub_status !== 'REGISTERED' && CBS.Registry.user.sub_status !== 'EX_SUBSCRIBER') { %>\n            <div class=\"bundle-lock-gradient\"></div>\n            <div class=\"label bundle-lock portrait\"><img src=\"/assets/images/svg/content_lock.svg\"/></div>\n          <% } %>\n        </div>\n    </a>\n\n    <% if(CBS.Registry.brand.name !== 'PPLUS') { %>\n    <div class=\"info-wrapper\">\n        <div class=\"title-wrapper\">\n            <span class=\"title\">\n                <a href=\"<%= href %>\" aa-link=\"<%= aaLink %>\" tabindex=\"-1\"><%= title %></a>\n            </span>\n        </div>\n    </div>\n    <% } %>\n</article>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@5791170504500865e593a2f8b06df046f98f6aab_fetch-_osudrbz7vv3ytx7t3wrw3ceh6e/node_modules/cbs-core-ui/src/js/templates/showBrowse/__showBrowseItem.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
var bundleLocked = false;
if(typeof contentLocked !== 'undefined' && contentLocked == true){
    bundleLocked = true;
}

    ; __line = 6
    ; __append("\n\n<article class=\"show-browse-item\">\n    <a class=\"focusable\" href=\"")
    ; __line = 9
    ; __append(escapeFn( href ))
    ; __append("\" aa-link=\"")
    ; __append(escapeFn( aaLink ))
    ; __append("\" data-fathom=\"")
    ; __append(escapeFn( fathomData ))
    ; __append("\" data-impression=\"")
    ; __append(escapeFn( impressionData ))
    ; __append("\">\n        <div class=\"thumb-wrapper\">\n          ")
    ; __line = 11
    ;  if(typeof thumb !== 'undefined'){ 
    ; __append("\n            <img class=\"thumb lazy\" src=\"data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=\" data-src=\"")
    ; __line = 12
    ; __append(escapeFn( thumb || '' ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( title ))
    ; __append("\" />\n          ")
    ; __line = 13
    ;  } 
    ; __append("\n          ")
    ; __line = 14
    ;  if(bundleLocked && CBS.Registry.user_auth && CBS.Registry.user.sub_status !== 'REGISTERED' && CBS.Registry.user.sub_status !== 'EX_SUBSCRIBER') { 
    ; __append("\n            <div class=\"bundle-lock-gradient\"></div>\n            <div class=\"label bundle-lock portrait\"><img src=\"/assets/images/svg/content_lock.svg\"/></div>\n          ")
    ; __line = 17
    ;  } 
    ; __append("\n        </div>\n    </a>\n\n    ")
    ; __line = 21
    ;  if(CBS.Registry.brand.name !== 'PPLUS') { 
    ; __append("\n    <div class=\"info-wrapper\">\n        <div class=\"title-wrapper\">\n            <span class=\"title\">\n                <a href=\"")
    ; __line = 25
    ; __append(escapeFn( href ))
    ; __append("\" aa-link=\"")
    ; __append(escapeFn( aaLink ))
    ; __append("\" tabindex=\"-1\">")
    ; __append(escapeFn( title ))
    ; __append("</a>\n            </span>\n        </div>\n    </div>\n    ")
    ; __line = 29
    ;  } 
    ; __append("\n</article>\n")
    ; __line = 31
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@5791170504500865e593a2f8b06df046f98f6aab_fetch-_osudrbz7vv3ytx7t3wrw3ceh6e/node_modules/cbs-core-ui/src/js/templates/showBrowse/__showBrowseItem.tpl"

}